import { NavigationGuardNext, Route } from 'vue-router';
import { canSelfServeSubscription, hasPermission, loggedIn, Permissions } from '@/ui/auth/auth';
import { NamedLocation, RouteName } from '../types';

const routesToBeIgnore: RouteName[] = ['noPlanPage'];
const isIgnoredRoute = (routeName: RouteName) => routesToBeIgnore.includes(routeName);

export function guardSubscriptionRoutes(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (isIgnoredRoute(to.name as RouteName)) {
    next();
  }

  if (!loggedIn.value) {
    next({ name: 'login' });
  } else {
    if (!hasPermission(Permissions.MANAGE_BILLING) || !canSelfServeSubscription.value) {
      const redirectTo: NamedLocation = { name: 'forbidden' };
      next(redirectTo);
    }

    next();
  }
}
